// Kept free of imports so Cypress specs can share these paths without loading apiService, which
// throws at import time when the API base URL env var is unset.
export const electralinkEndpoints = {
  encrypted_mpan_search: "/electralink/encmpan",
  postcode_search: "/electralink/postcode",
  decrypted_mpan_search: "/electralink/mpan",
  msn_search: "/electralink/msn",
  hh_aq_calc: "/electralink/halfhourly/forrender",
};
